import React from 'react'
import { Row, Col, Button } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppDispatch } from 'src/app/hooks'
import { setRegisterStep } from 'src/features'
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons'

interface RegisterUserStepChangerProps {
  nextStepValue: number,
  beforeStepValue?: number,
  loading?: boolean
  handleSubmitClick?: any
}

const RegisterUserStepChanger: React.FC<RegisterUserStepChangerProps> = (props) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const {
    nextStepValue, beforeStepValue = null,
    loading = false, handleSubmitClick = null
  } = props

  const isSubmitStep = nextStepValue === 4 && beforeStepValue === 3
  const labelState = !isSubmitStep ? 'next' : loading ? 'loading' : 'no_loading'

  const buttonLabel = {
    next: t('card.Continue'),
    loading: t('admin.Brokerage.CreatingUser'),
    no_loading: t('Auth.Register.SignUp')
  }[labelState]

  return <>
    <Row className={'register-form-continue-margin'}>
      {beforeStepValue ? <Col xs={12} lg={12}>
        <Button
          type='default'
          className='radius-100'
          icon={<ArrowLeftOutlined />}
          size={'large'}
          onClick={() => dispatch(setRegisterStep(beforeStepValue))}
        >
          {t('card.Back')}
        </Button>
      </Col> : <Col xs={12} lg={12} />}

      <Col xs={12} lg={12}>
        {handleSubmitClick ? <Button
          type='primary'
          htmlType='button'
          className='float-right radius-100'
          icon={<ArrowRightOutlined />}
          onClick={handleSubmitClick}
          size={'large'}
        >
          {t('card.Continue')}
        </Button> : <Button
          type='primary'
          htmlType='submit'
          className='float-right radius-100'
          loading={loading}
          icon={<ArrowRightOutlined />}
          size={'large'}
        >{buttonLabel}
        </Button>}
      </Col>
    </Row>
  </>
}

export default RegisterUserStepChanger
